module.exports = "pegasus/assets/email1-column-4.png";